import { ReactElement } from 'react'
import { StyledText } from '../../Atoms'
import { AttachedFilesFieldProps } from './props'
import {
    StyledStartIcon,
    StyledEndIcon,
    StyledIcon,
    StyledAttachedFilesField,
} from './styles'

const AttachedFilesField = ({
    active,
    text,
    onClick,
    startIcon,
    endIcon,
    Icon,
}: AttachedFilesFieldProps): ReactElement => {
    // Display Icons
    const displayRightIcon = active && <StyledEndIcon>{endIcon}</StyledEndIcon>
    const displayLeftIcon = active ? (
        <StyledStartIcon>{startIcon}</StyledStartIcon>
    ) : (
        <StyledIcon>{Icon}</StyledIcon>
    )
    return (
        <StyledAttachedFilesField onClick={onClick} active={active}>
            {displayLeftIcon}
            <StyledText>{text}</StyledText>

            {displayRightIcon}
        </StyledAttachedFilesField>
    )
}

export default AttachedFilesField
export { StyledAttachedFilesField }
